import React, { useState } from 'react';
import { Evaluation } from '../types/Scorecard';

interface EvaluationPopupProps {
    isOpen: boolean;
    onClose: () => void;
    registrant: any; // Replace with the appropriate type for registrant
    evaluations: Evaluation[]; // Replace with the appropriate type for evaluations
}

const EvaluationPopup: React.FC<EvaluationPopupProps> = ({ isOpen, onClose, registrant, evaluations }) => {
    const [showAllEvaluations, setShowAllEvaluations] = useState(false);

    if (!isOpen) return null;

    // Filter to show only the most recent evaluation per judge by default
    const recentEvaluations = evaluations
        .sort((a, b) => {
            // Sort by judge_id (alphabetically)
            const judgeComparison = a.judge_id.localeCompare(b.judge_id);

            // If judge_id is equal, sort by the most recent created_at (in descending order)
            const createdAtComparison =
                new Date(b.created_at ?? Date.now()).getTime() - new Date(a.created_at ?? Date.now()).getTime();

            return judgeComparison || createdAtComparison;
        }).reduce((acc, curr) => {
            if (!acc.some(item => item.judge_id === curr.judge_id)) {
                acc.push(curr);
            }
            return acc;
        }, [] as Evaluation[]);

    // Toggle logic between recent and all evaluations
    const displayedEvaluations = showAllEvaluations ? evaluations : recentEvaluations;

    return (
        <div
            className="popOverBackdrop"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
            }}
            onClick={onClose}
        >
            <div
                className="popOverContainer"
                style={{
                    position: 'relative',
                    background: 'white',
                    borderRadius: '8px',
                    padding: '20px',
                    width: '80%',
                    maxWidth: '600px',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
                }}
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the popover
            >
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        background: 'transparent',
                        color: 'gray',
                        border: 'none',
                        cursor: 'pointer',
                        outline: 'none',
                        maxHeight: '60px',
                        fontWeight: 'bold',
                        fontSize: '24px'
                    }}
                >X</button>

                <h2>
                    {registrant.first_name} {registrant.last_name}'s Evaluations
                </h2>

                <label style={{ display: 'block', marginBottom: '20px' }}>
                    <input
                        type="checkbox"
                        checked={showAllEvaluations}
                        onChange={() => setShowAllEvaluations(!showAllEvaluations)}
                        style={{ marginRight: '10px' }}
                    />
                    Show All Evaluations
                </label>

                <ul>
                    {displayedEvaluations.map((evalItem, index) => (
                        <div className="card" style={{ marginBottom: '10px' }}>
                            <li key={index}>
                                <strong>Judge:</strong> {evalItem.first_name || evalItem.judge_id} {evalItem.last_name || ''} <br />
                                <strong>Score:</strong> {evalItem.total_score}% <br />
                                <strong>Comments:</strong> {evalItem.comments || 'None'}
                                <br />
                                <strong>Created At:</strong> {new Date(evalItem.created_at ?? Date.now()).toLocaleString()}
                                {evalItem.results && evalItem.results.length > 0 && (
                                    <div style={{ marginTop: '10px' }}>
                                        <strong>Details:</strong>
                                        <ul>
                                            {evalItem.results.map((result, idx) => (
                                                <li key={idx}>
                                                    <strong>Question:</strong> {result.question}<br />
                                                    <strong>Points:</strong> {result.point_value}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </li>
                        </div>
                    ))}
                </ul>
                {displayedEvaluations.length == 0 &&<h3><i>No viewable evaluations.</i></h3>}


                <div className="buttonsRow" style={{ marginTop: '20px', textAlign: 'right' }}>
                    <div className='buttonsRight'></div>
                    <button
                        style={{
                            fontSize: '16px',
                            backgroundColor: '#888888',
                            color: 'white',
                            padding: '10px 20px',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                        }}
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EvaluationPopup;
